import { FC, PropsWithChildren } from 'react';
import { Tooltip as TippyTooltip, TooltipProps as TippyTooltipProps } from 'react-tippy';
import 'react-tippy/dist/tippy.css';

type TooltipComponentProps = Pick<
  TippyTooltipProps,
  'title' | 'position' | 'animation' | 'multiple' | 'disabled' | 'className' | 'html' | 'followCursor' | 'delay'
>;

export const Tooltip: FC<PropsWithChildren<TooltipComponentProps>> = ({
  title,
  children,
  position = 'bottom',
  animation = 'none',
  multiple,
  disabled = false,
  className,
  html,
  followCursor = true,
  delay = 0,
}) => (
  // @ts-ignore - children-not-in-props type error
  <TippyTooltip
    className={className}
    title={title}
    html={html}
    position={position}
    arrow={false}
    trigger="mouseenter"
    animation={animation}
    animateFill={false}
    followCursor={followCursor}
    delay={delay}
    duration={0}
    // @ts-ignore - zIndex is missing in types
    zIndex={2147483644}
    multiple={multiple}
    disabled={disabled}
  >
    {children}
  </TippyTooltip>
);
